import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MaterialService } from '../../../services/material.services';
import Swal from 'sweetalert2';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { VersionImgSliderComponent } from '../../shared/version-img-slider/version-img-slider.component'
import { MainService } from '../../../services/main.services';

@Component({
  selector: 'app-material-version-list',
  templateUrl: './material-version-list.component.html',
  styleUrl: './material-version-list.component.scss'
})
export class MaterialVersionListComponent {
     constructor(private router: Router,
      private _params: ActivatedRoute,
      private matService : MaterialService,
      private dialogService: DialogService,
      private mainService : MainService
     ) {
         this._params.params.subscribe((params : any) => {
          console.log(params.camp_id, params.box_id, params.mat_id)
          if(params.camp_id && params.box_id && params.mat_id){
            this.camp_id = params.camp_id;
            this.claw_camp_id = params.claw_camp_id;
            this.box_id = params.box_id;
            this.group_id = params.mat_id;

            if(params.sesion){
              this.hasSesion = true;
              this.sesion = this.mainService.deserializeObj(params.sesion);
            }
          }else{
            Swal.fire({
            title: 'Error',
            text: 'Se han proporcionado datos incorrectos',
            icon: 'error',
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            showConfirmButton: false,
            showCloseButton: false
          });
          }
        });
     }

     claw_camp_id =0;
     camp_id = 0;
     box_id = 0;
     group_id = 0;
     hasSesion : boolean = false;
     ref: DynamicDialogRef | undefined;
     loaded = false;

     material_info : any = [];
     mat_name = "";

     search = '';
     capturedCount = 0;
     cantidadCount = 0;


  ngOnInit(): void {
    this.getVersions();
  }

  filtroCaptura = false;
  ordenAscendente = true;
  ordenActivo = false; 
  sesion : any = {};
  menuItems: any[] = [];

  private buildMenuItems() {
    this.menuItems = [
      {
        label: 'Ordenar',
        items: [
          {
            label: this.ordenAscendente ? 'Mayor a menor' : 'Menor a mayor',
            icon: this.ordenAscendente ? 'pi pi-sort-amount-down' : 'pi pi-sort-amount-up',
            command: () => {
              this.ordenAscendente = !this.ordenAscendente;
              this.ordenActivo = true; 
              this.buildMenuItems();
            }
          }
        ]
      },
      {
        label: 'Filtrar',
        items: [
          {
            label: this.filtroCaptura ? 'Mostrar todos' : 'Mostrar capturadas',
            icon: this.filtroCaptura ? 'pi pi-filter-slash' : 'pi pi-filter',
            command: () => {
              this.filtroCaptura = !this.filtroCaptura;
              this.buildMenuItems();
            }
          }
        ]
      },
   //  { separator: true },
   //  {
   //    label: 'Resetear filtros',
   //    icon: 'pi pi-refresh',
   //    command: () => {
   //      this.resetFilters();
   //    }
   //  }
    ];
  }

  resetFilters() {
    this.filtroCaptura = false;
    this.ordenAscendente = true;
    this.ordenActivo = false; 
    this.buildMenuItems();
  }

  get sortedMaterialInfo(): any[] {
    if (!this.material_info) {
      return [];
    }

    let material_data = this.material_info;

    if (this.search?.trim()) {
      const searchValue = this.search.toLowerCase().trim();

      material_data = this.material_info.filter( (material:any) =>
        material.versiones?.some( (version:any) =>
          version.material?.toLowerCase().includes(searchValue) ||
          version.texto?.toLowerCase().includes(searchValue)
        )
      );
    }

    //Que siempre inicie en orden ascendente
    material_data = [...material_data].sort((a, b) => {
      return a.nombre.localeCompare(b.nombre);
    });

    if (!this.ordenActivo) {
      return material_data; 
    }
    
    return [...material_data].sort((a, b) => {
      return this.ordenAscendente ? a.nombre.localeCompare(b.nombre) : b.nombre.localeCompare(a.nombre);
    });
  }

  getFilteredAndSortedVersions(versiones: any[]): any[] {
    /* let resultado = this.filtroCaptura ? versiones.filter(v => v.capturas > 0) : [...versiones];
    
    if (!this.ordenActivo) {
      return resultado; 
    }

    return resultado.sort((a, b) => {
      const versionA = parseInt(String(a.version || '').match(/\d+/)?.[0] || '0');
      const versionB = parseInt(String(b.version || '').match(/\d+/)?.[0] || '0');
      return this.ordenAscendente ? versionA - versionB : versionB - versionA;
    }); */

    let resultado = [...versiones];

    if (this.search?.trim()) {
      const searchValue = this.search.toLowerCase().trim();

      resultado = resultado.filter(v =>
        v.material?.toLowerCase().includes(searchValue) ||
        v.texto?.toLowerCase().includes(searchValue)
      );
    }

    if (this.filtroCaptura) {
      resultado = resultado.filter(v => v.capturas > 0);
    }

    if (!this.ordenActivo) {
      return resultado;
    }

    return resultado.sort((a, b) => {
      const versionA = parseInt(String(a.version || '').match(/\d+/)?.[0] || '0', 10);
      const versionB = parseInt(String(b.version || '').match(/\d+/)?.[0] || '0', 10);

      return this.ordenAscendente
        ? versionA - versionB
        : versionB - versionA;
    });

  }

  onCapture(item:any, version : any){

    let versionRet = {id: item.id,
        nombre: item.nombre,
        id_grupo: item.id_grupo,
        id_m: item.id_m,
        url: version.url,
        version: version.version,
        capturas: version.capturas,
        texto: version.texto,
       }


    const data = {
      claw_camp_id: this.claw_camp_id,
      camp_id: this.camp_id,
      id_grupo: item.id_grupo,
      mat_nombre: item.nombre,
      mat_id: item.id,
      box_id : this.box_id,
      version : versionRet,
      material_img : version.url || 'assets/images/example-mat.png',
    };

    let dataStr = this.mainService.serializeObj(data);
    this.router.navigate(['/material-scan/' + dataStr ]);
     //this.router.navigate(['/material-scan/' + this.claw_camp_id + '/' +  this.camp_id + '/' + item.id_grupo + '/' + item.nombre + '/' + item.id ]);
  }

    selected : any;
    
    select(item: any, mat : any) {
      if(this.hasSesion){
         this.selected = item;

            setTimeout(() => {
               let selected_version = { mat : mat , selected_version : this.selected }
               this.sesion["selected_version"] = selected_version;
               let dataStr = this.mainService.serializeObj(this.sesion);
               this.router.navigate(['/material-compare/' + dataStr ]);
           }, 200);
      }
      
    }

    getVersions(){
       Swal.fire({
           title: 'Cargando versiones...',
           text: 'Esto puede tardar unos segundos',
           allowOutsideClick: false,
           didOpen: () => {
             Swal.showLoading();
           }
       });
     this.matService.getVersionsData(this.claw_camp_id, this.box_id, this.group_id).subscribe((x:any)=>{
      console.log(x.message, x.data);
      if(x.message === 'Success'){
        console.log(x.data);

           this.material_info = x.data
           if(this.material_info.length != 0){
             this.mat_name = this.material_info[0].grupo;
           }
           this.material_info.map((info:any)=>{
              if(info.versiones.length == 0){
                info.versiones.push({
                  capturas: info.capturas,
                  omitidos: info.omitidos,
                  material: info.nombre,
                  texto:"",
                  url: "assets/images/example-mat.png",
                  version: 1
                })
              }
           });
           this.buildMenuItems();
          //this.versiones = x.data.versio
          this.updateCantidadCount();
          this.updateCapturedCount();
          this.loaded = true;
          Swal.close();
      }else{
        Swal.close();
        Swal.fire('Error', 'Oops, algo salió mal, por favor intente más tarde', 'error');
      }
     });
    }


    onOpenImage(item : any, mat: any){

      this.selected = item

      let selected_version = { mat : mat , selected_version : this.selected }
      this.sesion["selected_version"] = selected_version;
      let dataStr = this.mainService.serializeObj(this.sesion);

      if(item.url != "assets/images/example-mat.png"){
        this.ref = this.dialogService.open(VersionImgSliderComponent, {
         header: 'Versiones',
         width: '700px',
         contentStyle: { 'max-height': '790px', overflow: 'auto' },
                breakpoints: {
                   '960px': '75vw',
                   '640px': '90vw'
               },
         baseZIndex: 10000,
         data: [{url: item.url, hasSesion: this.hasSesion, dataStr: dataStr}]
       });
      }
  }

    onOpenImageOld(item : any){
      if(item.versiones.length != 0){
        this.ref = this.dialogService.open(VersionImgSliderComponent, {
        header: 'Versiones',
        width: '700px',
        contentStyle: { 'max-height': '790px', overflow: 'auto' },
               breakpoints: {
                  '960px': '75vw',
                  '640px': '90vw'
              },
        baseZIndex: 10000,
        data: item.versiones
      });
      }else{
          Swal.fire({
          title: 'Aviso',
          text: 'Este material no tiene imágenes para mostrar',
          icon: 'warning',
         });
      }
  
    }

updateCapturedCount() {
  if (!this.material_info) {
    this.capturedCount = 0;
    return;
  }

  this.capturedCount = this.material_info.reduce(
    (acc: number, grupo: any) =>
      acc + grupo.versiones.filter((v: any) => v.capturas > 0).length,
    0
  );
}

updateCantidadCount() {
  if (!this.material_info) {
    this.cantidadCount = 0;
    return;
  }

  this.cantidadCount = this.material_info.reduce(
    (acc: number, grupo: any) => acc + grupo.versiones.length,
    0
  );
}

 omitItem(item:any, version : any){
        Swal.fire({
        text: '¿Está seguro que desea omitir este material?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        customClass: {
          popup: 'swal-font',
          confirmButton: 'swal-confirm-btn',
          cancelButton: 'swal-cancel-btn'
        },
        buttonsStyling: false,
        reverseButtons: true 
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
              title: 'Ejecutando proceso...',
              text: 'Esto puede tardar unos segundos',
              allowOutsideClick: false,
              didOpen: () => {
                Swal.showLoading();
              }
         });
          this.matService.omitItem(this.claw_camp_id, this.box_id, this.camp_id, item.id_grupo, item.id, version.version).subscribe({
            next: (x: any) => {
              console.log(x.message, x.data);
                   Swal.hideLoading();
                Swal.close();
                Swal.fire({
                  icon: 'success',
                  title: '¡Proceso completado!',
                  text: 'El material se ha omitido correctamente.',
                  confirmButtonText: 'Aceptar'
                }).then(r => {
                  this.getVersions();
                });

            },
            error: (err) => {
              console.error('Error en omitItem:', err);
                 Swal.hideLoading();
              Swal.fire({
                icon: 'error',
                title: 'Error al omitir',
                text: 'Intenta nuevamente más tarde.',
                confirmButtonText: 'Aceptar'
              });
            }
          });
        }
      });
    }

}
